import React, {Component} from 'react';
import { withRouter } from 'react-router-dom'
import ImageApi from "../api/ImageApi";
import ProgressiveImage from "../components/ProgressiveImage";
import Loader from "../components/Loader";
import AppLink from "../components/AppLink";
import PostList from "../components/PostList";
import MetaTags from "../components/MetaTags";
import Breadcrumb from "../components/Breadcrumb";
import SwipeArea from "../components/SwipeArea";
import VideoApi from "../api/VideoApi";
import VideoPlayer from "../components/VideoPlayer";
import SwitchingBanner from "../components/ads/SwitchingBanner";
import VoteButton from "../components/VoteButton";
import FavoriteButton from "../components/FavoriteButton";
import UserApi from "../api/UserApi";
import SuggestButton from "../components/SuggestButton";
import TagLink from "../components/TagLink";

class Image extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      object: {},
      pagination: {},
      meta_tags: {},
      voteData: {}
    };

    this.onVisitImage = this.onVisitImage.bind(this);
  }

  componentDidMount() {
    if (!this.props.match.params.section) {
      this.props.history.replace(`/${this.isGif() ? "gif" : "image"}/new/${this.props.match.params.slug}${window.location.search}`);
    }

    this.loadImage();

    window.addEventListener('userStatusChanged', this.onUserStateChange.bind(this))
  }

  componentWillUnmount() {
    window.removeEventListener('userStatusChanged', this.onUserStateChange.bind(this))
  }

  componentDidUpdate(prevProps) {
    if (prevProps.match.params.slug !== this.props.match.params.slug) {
      this.loadImage();
    }
  }

  onUserStateChange() {
    if (window.user.isGuest()) {
      return this.setState({ voteData: {} });
    }

    this.loadVoteData();
  }

  loadImage() {
    const { slug, section, tag } = this.props.match.params;

    this.setState({
      loading: true,
      object: {},
      pagination: {},
      meta_tags: {}
    }, () => {
      if (this.isGif()) {
        VideoApi.details(slug, { related: 4 }).then(res => {
          this.setState({
            loading: false,
            object: res.data.data,
            meta_tags: res.data.meta_tags
          })
        }).then(() => {
          ImageApi.pagination("video", slug, {
            section: section,
            tags: tag
          }).then(res => {
            this.setState({
              pagination: res.data
            })
          });

          this.loadVoteData();
        });
      } else {
        ImageApi.details(slug, { related: 4 }).then(res => {
          this.setState({
            loading: false,
            object: res.data.data,
            meta_tags: res.data.meta_tags
          })
        }).then(() => {
          ImageApi.pagination("image", slug, {
            section: section,
            tags: tag
          }).then(res => {
            this.setState({
              pagination: res.data
            })
          });

          this.loadVoteData();
        });
      }
    })
  }

  loadVoteData() {
    if (window.user.isGuest()) {
      return;
    }

    UserApi.voteData(this.state.object).then(res => {
      this.setState({ voteData: res.data.data });
    })
  }

  onVisitImage(direction) {
    const { section, tag } = this.props.match.params;
    const { pagination } = this.state;

    const append = (section ? `${section}/` : "new/") + (tag ? `${tag}/` : "");
    let url = null;

    switch (direction) {
      case "prev":
        if (!this.state.pagination.prev || !this.state.pagination.prev.id) {
          return;
        }

        url = (pagination.prev.type === "Video" ? `/gif/${append}` : `/image/${append}`) + pagination.prev.id;
        break;
      default:
        if (!this.state.pagination.next || !this.state.pagination.prev.id) {
          return;
        }

        url = (pagination.next.type === "Video" ? `/gif/${append}` : `/image/${append}`) + pagination.next.id;
        break;
    }

    this.props.history.push(url);
  }

  isGif() {
    return this.props.location.pathname.substring(1, 4) === "gif";
  }

  render() {
    const { object, loading, pagination, meta_tags, voteData } = this.state;
    const { section, tag } = this.props.match.params;

    if (loading) {
      return <Loader />;
    }

    const url = (section ? `${section}/` : "new/") + (tag ? `${tag}/` : "");

    let prevUrl = null;
    if (pagination && pagination.prev && pagination.prev.id) {
      prevUrl = (pagination.prev.type === "Video" ? `/gif/${url}` : `/image/${url}`) + pagination.prev.id;
    }

    let nextUrl = null;
    if (pagination && pagination.next && pagination.next.id) {
      nextUrl = (pagination.next.type === "Video" ? `/gif/${url}` : `/image/${url}`) + pagination.next.id;
    }

    const paging = (
      <div className={'paging'}>
        <div className={'row'}>
          <div className={'col-6 col-lg-4 offset-lg-2'}>
            {prevUrl && <AppLink className={'btn btn-default btn-block'} to={prevUrl}>Prev</AppLink>}
          </div>
          <div className={'col-6 col-lg-4'}>
            {nextUrl && <AppLink className={'btn btn-default btn-block'} to={nextUrl}>Next</AppLink>}
          </div>
        </div>
      </div>
    );

    return (
      <React.Fragment>
        <Breadcrumb items={[ { name: "Images", url: `/images/${section}` }, tag ? { name: tag, url: `/images/${section}/${tag}` } : {}, { name: (object.title || "Untitled") } ]}/>
        <section className={'container'}>
          <MetaTags meta_tags={meta_tags} />

          <SwitchingBanner className={"mt-2"} mobileBanner={"300x100"} />

          <div className={'image-view detail-page'}>
            {paging}

            <div className={'row'}>
              <div className={'col-12 col-lg-10 offset-lg-1'}>
                <SwipeArea onLeft={() => { this.onVisitImage('prev'); }} onRight={() => { this.onVisitImage('next'); }} onSwipeLeft={() => { this.onVisitImage('next') }} onSwipeRight={() => { this.onVisitImage('prev') }}>
                  <div className={'image-wrapper'}>
                    {this.isGif() ? (
                      <VideoPlayer key={object.slug} video={object} autoplay={true} muted={true} loop={true} controls={true} />
                    ) : (
                      <React.Fragment>
                        <ProgressiveImage image={object.preview} size={'full'} className={'img-fluid'} />
                        {prevUrl && <AppLink to={prevUrl} className={'prev'} />}
                        {nextUrl && <AppLink to={nextUrl} className={'next'} />}
                      </React.Fragment>
                    )}
                  </div>
                </SwipeArea>
              </div>
            </div>

            <h1 className={'content-headline'}>{object.title || "Untitled"}</h1>
            {object.published_ago && <div className={'text-right mb-3'}>published {object.published_ago} ago</div>}

            <div className={'row'}>
              <div className={'col-6 col-lg-4 offset-lg-2'}>
                <VoteButton object={object} type={"like"} voteData={voteData} />
              </div>
              <div className={'col-6 col-lg-4'}>
                <VoteButton object={object} type={"dislike"} voteData={voteData} />
              </div>
            </div>

            <div className={'row mt-3'}>
              <div className={'col-12 col-lg-8 offset-lg-2'}>
                <FavoriteButton object={object} voteData={voteData} />
              </div>
            </div>

            <div className={'tags'}>
              {object.tags.map(tag => {
                return <TagLink key={tag.slug + Math.random()} tag={tag} section={section} type={"images"} subscribed={voteData && voteData.subscribed && voteData.subscribed.includes(tag.slug)} />
              })}
            </div>

            <div className={'row'}>
              <div className={'col-12 col-lg-4 offset-lg-4'}>
                <SuggestButton object={object} />
              </div>
            </div>
          </div>

          {object.related && (
            <div className={'related mb-3'}>
              <h3 className={'section-headline'}>More like this</h3>

              <PostList posts={object.related} section={section} tag={tag} containerProps={{ imageSize: this.isGif() ? "large" : "thumb", layout: "full" }} />
            </div>
          )}

          {paging}

          <SwitchingBanner className={"mt-3"} />
        </section>
      </React.Fragment>
    );
  }
}

export default withRouter(Image);